import _implicitStylesheets from "./videoPreview.css";
import _implicitScopedStylesheets from "./videoPreview.scoped.css?scoped=true";
import _adsIcon from "ads/icon";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"a0:src"}${"c0"}${"a0:alt"}${2}>`;
const $fragment2 = parseFragment`<img${"a0:src"} class="provider__logo${0}" alt=""${2}>`;
const $fragment3 = parseFragment`<h2 type-style="display-6"${3}>${"t1"}</h2>`;
const stc0 = {
  "type": "image"
};
const stc1 = {
  classMap: {
    "preview__content": true
  },
  key: 4
};
const stc2 = {
  classMap: {
    "preview__icons": true
  },
  key: 5
};
const stc3 = {
  classMap: {
    "play__button": true
  },
  key: 6
};
const stc4 = {
  classMap: {
    "play__icon": true
  },
  props: {
    "size": "large",
    "symbol": "play"
  },
  key: 7
};
const stc5 = {
  classMap: {
    "preview__text": true
  },
  key: 10
};
const stc6 = {
  classMap: {
    "new_window__icon": true
  },
  props: {
    "size": "medium",
    "symbol": "new_window"
  },
  key: 13
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, ncls: api_normalize_class_name, sp: api_static_part, st: api_static_fragment, c: api_custom_element, h: api_element, d: api_dynamic_text} = $api;
  const {_m0, _m1} = $ctx;
  return [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc0,
    key: 0,
    on: {
      "analytics": _m0 || ($ctx._m0 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("button", {
    className: api_normalize_class_name($cmp.containerClass),
    attrs: {
      "role": $cmp.buttonRole
    },
    key: 1,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClick))
    }
  }, [api_static_fragment($fragment1, 3, [api_static_part(0, {
    className: api_normalize_class_name($cmp.backgroundClass),
    attrs: {
      "src": $cmp.backgroundImage,
      "alt": $cmp.altText
    }
  }, null)]), api_element("div", stc1, [api_element("div", stc2, [api_element("div", stc3, [api_custom_element("ads-icon", _adsIcon, stc4)]), api_static_fragment($fragment2, 9, [api_static_part(0, {
    attrs: {
      "src": $cmp.logo
    }
  }, null)])]), api_element("div", stc5, [api_static_fragment($fragment3, 12, [api_static_part(1, null, api_dynamic_text($cmp.displayText))]), $cmp.showNewWindowIcon ? api_custom_element("ads-icon", _adsIcon, stc6) : null])])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-7vefb8p8917";
tmpl.legacyStylesheetToken = "undefined-_videoPreview";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
